export default __webpack_public_path__ + "static/media/tlife.ca084c75.png";